
import {
  EjerciciosEmpresa,
  EmpresasUsuarioLogado,
} from "@/model/UsuarioLogado";
import { AuthService } from "@/services/Auth";
import { UsuarioService } from "@/services/UsuarioService";
import { Constantes } from "@/Util/Constantes";
import {
  AutoCompleteTemplate,
  Combo,
  ComboEnum,
  Utilidades,
} from "@/Util/Utilidades";
import { IdiomaService } from "@/services/IdiomaService";
import Vue from "vue";
import { Idioma } from "@/model/Idioma";
import router from "@/router";
import { ComboService } from "@/services/ComboService";
import btnActualizar from "./btnActualizar.vue";
import { EmpresaFactService } from "@/services/EmpresaFactService";
import { EmpresaFact } from "@/model/EmpresaFact";
import Autocomplete from "./Autocomplete.vue";

// import "@/assets/hyper/js/hyper-config.js";
export default Vue.extend({
  components: {
    btnActualizar,
    Autocomplete,
  },
  name: "Topbar",
  data() {
    return {
      usuario: AuthService.getUsuario(),
      interval: null,
      time: null,
      date: null,
      empresasUsuario: new Array<Object>() as Array<EmpresasUsuarioLogado>,
      ejerciciosEmpresa: new Array<Object>() as Array<EjerciciosEmpresa>,
      perfilesUsuario: new Array<Object>() as Array<AutoCompleteTemplate>,
      empresaSeleccionada: new Object() as EmpresasUsuarioLogado,
      perfilSeleccionado: null as string,
      ejercicioSeleccionado: new Object() as EjerciciosEmpresa,
      rota_home: false as boolean,
      empFact: new Object() as EmpresaFact,
      idiomas: new Array<Object>() as Array<Idioma>,
      idiomaSeleccionado: new Object() as Idioma,
      loading: false as boolean,
      loadingEjerciciosEmpresa: false as boolean,
      desarrollo: false as boolean,
      combo: new Array<Combo>(),
      combos: {
        tipo_documentos: new Array<AutoCompleteTemplate>(),
        padres: new Array<AutoCompleteTemplate>(),
        paises: new Array<AutoCompleteTemplate>(),
      },
      mensaje_caducidad_clave: "" as string,
      mostrar_mensaje_caducidad_clave: false as boolean,
      dialogSalir: false as boolean,
    };
  },
  computed: {},
  beforeDestroy() {
    clearInterval(this.interval);
  },
  async mounted() {
    try {
      await this.cargarCombos();
      await this.cargarEmpresas();
      await this.cargarPerfiles();
      await this.cargarIdiomas();
      await this.cargarEmpFact();
      this.mostrar_mensaje_clave();

      this.$root.$emit("actualizarMenu");
      Utilidades.forzarActualizacionPantalla(this);
    } catch (ex) {
      Utilidades.Message({ message: ex.toString(), error: true, timeout: -1 });
    }
  },
  async created() {
    // update the time every second
    this.desarrollo = this.$store.state.ambiente == "DESARROLLO";
    this.interval = setInterval(() => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.time = Intl.DateTimeFormat(navigator.language, {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      }).format();

      this.date = Intl.DateTimeFormat(navigator.language, {
        day: "numeric",
        month: "numeric",
        year: "numeric",
      }).format();
    }, 1000);
  },
  watch: {
    "$route.name": {
      immediate: true,
      deep: true,
      handler(value) {
        this.rota_home = this.$route.name != "home";
      },
    },
    "$store.state.ambiente": {
      immediate: true,
      deep: true,
      handler() {
        this.desarrollo = this.$store.state.ambiente == "DESARROLLO";
      },
    },
  },
  methods: {
    async logout(): Promise<void> {
      AuthService.logout();
    },  
    mostrar_mensaje_clave() {
      let dias = AuthService.getUsuario()?.dias;
      this.mensaje_caducidad_clave = Utilidades.traduccion({
        texto: "Su plan clave vá caducar en #DIAS# dias",
        tag: "SU_CLAVE_VA_CADUCAR_EN_#DIAS#_DIAS",
      });
      this.mensaje_caducidad_clave = this.mensaje_caducidad_clave.replaceAll(
        "#DIAS#",
        dias.toString()
      );

      if (Utilidades.isNullOrUndefinedOrZero(dias) || dias <= 7) {
        this.mostrar_mensaje_caducidad_clave = true;
        this.mensaje_caducidad_clave =
          "Su plan clave vá caducar en #DIAS# dias";
      }
    },
    cambiarClave() {
      this.$router.push({ name: "cambiarClave" });
    },
    borrarCuenta() {
      this.$router.push({ name: "borrar-cuenta" });
    },
    traerTablasMaestras() {
      this.$router.push({ name: "traer-tablas-maestras" });
    },
    // logout() {
    //   //AuthService.logout();
    //   this.$router.push({ name: "salir" });
    // },
    async cambiarEmpresaSeleccionada() {
      this.loading = true;
      this.$root.$emit("preloader", this.loading);
      AuthService.updateEmpresaSeleccionada(
        this.empresaSeleccionada.id_empresa
      );
      await this.cargarEjercicios();
      this.loading = false;
      this.$root.$emit("preloader", this.loading);
    },
    async cambiarEjercicioSeleccionado(mensaje_ok: boolean = true) {
      this.loading = true;
      this.$root.$emit("preloader", this.loading);

      await UsuarioService.ejercicioDefecto(
        this.ejercicioSeleccionado.id_empresa_ejercicio
      )
        .then((response) => {
          AuthService.updateEjercicioEmpresaSeleccionado(
            this.ejercicioSeleccionado.id_empresa_ejercicio
          );

          //Eso es para que no pinte el mensaje después de hacer el login o actualizar la pagina con CTRL+F5 o F5
          /*if(mensaje_ok){
            Utilidades.Message({ message: Constantes.ACTUALIZAR_DATOS });
          }*/
        })
        .catch((y) => {
          Utilidades.Message({
            message: Constantes.ERROR_ACTUALIZAR_DATOS + " " + y.response.data,
            error: true,
          });
        });

      this.loading = false;
      this.$root.$emit("preloader", this.loading);
    },
    async cambiarPerfilSeleccionado() {
      this.loading = true;
      this.$root.$emit("preloader", this.loading);

      await UsuarioService.perfilDefecto(this.perfilSeleccionado)
        .then((response) => {
          AuthService.updatePerfilSeleccionado(this.perfilSeleccionado);

          //Utilidades.Message({ message: Constantes.ACTUALIZAR_DATOS });
          this.$root.$emit("actualizarMenu");
        })
        .catch((y) => {
          Utilidades.Message({
            message: Constantes.ERROR_ACTUALIZAR_DATOS + " " + y.response.data,
            error: true,
          });
        })
        .finally(() => {
          this.loading = false;
          this.$root.$emit("preloader", this.loading);
        });
    },
    async cargarIdiomas() {
      await IdiomaService.cargarIdiomas()
        .then((x) => (this.idiomas = x.data))
        .catch();

      this.idiomaSeleccionado = this.idiomas.find((x) => x.selected == 1);

      if (!this.idiomaSeleccionado) {
        this.idiomaSeleccionado = this.idiomas[0];
      }

      if (
        this.idiomaSeleccionado?.id_idioma !=
        AuthService.getUsuario()?.id_idioma
      ) {
        AuthService.updateIdioma(this.idiomaSeleccionado);
      }
    },
    async cambiarIdioma(id: string) {
      await IdiomaService.cambiarIdioma(id)
        .then(async (x) => {
          AuthService.updateLanguage(x.data);
          await Utilidades.sleep(100);
          window.location.reload();
        })
        .catch((y) =>
          Utilidades.Message({
            message: Constantes.ERROR_ACTUALIZAR_DATOS + " " + y.response.data,
            error: true,
          })
        );
    },
    async cargarCombos() {
      await this.cargarPadres();
      await this.cargarTipoDocumentos();
      await this.cargarPaises();
    },
    async cargarPadres() {
      let filtro = "-1&";
      await ComboService.getComboRaw(ComboEnum.TP_EMPRESA_FACTURACION, filtro)
        .then((response) => {
          this.combo = response.data;
        })
        .catch((x) => Utilidades.Message({ message: x.response, error: true }));

      this.combos.padres = new Array<Object>() as Array<AutoCompleteTemplate>;

      this.combo.forEach((x) => {
        this.combos.padres.push(new AutoCompleteTemplate(x.texto, x.id));
      });
    },
    async cargarTipoDocumentos() {
      let filtro = "1&";
      await ComboService.getComboRaw(ComboEnum.TM_TIPO_DOCUMENTO, filtro)
        .then((response) => {
          this.combo = response.data;
        })
        .catch((x) => Utilidades.Message({ message: x.response, error: true }));

      this.combos.tipo_documentos =
        new Array<Object>() as Array<AutoCompleteTemplate>;

      this.combo.forEach((x) => {
        this.combos.tipo_documentos.push(
          new AutoCompleteTemplate(x.texto, x.id)
        );
      });
    },
    async cargarPaises() {
      let filtro = "1&";
      await ComboService.getComboRaw(ComboEnum.TM_PAIS, filtro)
        .then((response) => {
          this.combo = response.data;
        })
        .catch((y) =>
          Utilidades.Message({
            message: y.response.data,
            error: true,
          })
        );

      this.combos.paises = new Array<Object>() as Array<AutoCompleteTemplate>;

      this.combo.forEach((x) => {
        this.combos.paises.push(new AutoCompleteTemplate(x.texto, x.id));
      });
    },
    async cargarEmpresas() {
      try {
        this.empresasUsuario = new Array<EmpresasUsuarioLogado>();

        let filtro = "0&";
        await ComboService.getComboRaw(ComboEnum.TP_EMPRESA, filtro)
          .then((x) => {
            x.data.forEach((item) => {
              let obj = new Object() as EmpresasUsuarioLogado;
              obj.id_empresa = item.id;
              obj.nombre_empresa = item.texto;
              obj.css = item.css_texto;
              obj.header = item.header;
              obj.defecto = item.enc_defecto == Utilidades.UNO;
              this.empresasUsuario.push(obj);
            });
          })
          .catch((ex) => {
            Utilidades.Message({
              message: ex.response?.data,
              error: true,
            });
          });

        if (this.empresasUsuario.length == 1) {
          this.empresaSeleccionada = this.empresasUsuario[0];
        } else {
          var defecto = this.empresasUsuario.find((x) => x.defecto == true);

          if (defecto) {
            this.empresaSeleccionada = defecto;
          } else {
            this.empresaSeleccionada = this.empresasUsuario[0];
          }
        }
      } catch (ex) {
        Utilidades.Message({
          message: ex.toString(),
          error: true,
        });
      } finally {
        await this.cambiarEmpresaSeleccionada();
      }
    },
    async cargarEjercicios() {
      let filtro = "";

      try {
        filtro = AuthService.getUsuario().id_empresa_seleccionado;
        this.loadingEjerciciosEmpresa = true;
        this.ejerciciosEmpresa = new Array<EjerciciosEmpresa>();

        await ComboService.getComboRaw(
          ComboEnum.TP_EMPRESA_EJERCICIO,
          filtro
        ).then((x) => {
          let obj = new Object() as EjerciciosEmpresa;
          x.data.forEach((item) => {
            obj = new Object() as EjerciciosEmpresa;
            obj.id_empresa_ejercicio = item.id;
            obj.cod_empresa_ejercicio = item.texto;
            obj.defecto = item.enc_defecto == Utilidades.UNO;
            this.ejerciciosEmpresa.push(obj);
          });
        });

        if (this.ejerciciosEmpresa.length == 1) {
          this.ejercicioSeleccionado = this.ejerciciosEmpresa[0];
        } else {
          var defecto = this.ejerciciosEmpresa.find((x) => x.defecto == true);

          if (defecto) {
            this.ejercicioSeleccionado = defecto;
          } else {
            this.ejercicioSeleccionado = this.ejerciciosEmpresa[0];
          }
        }
      } catch (ex) {
        Utilidades.Message({
          message: ex.toString(),
          error: true,
        });
      } finally {
        this.loadingEjerciciosEmpresa = false;
        this.cambiarEjercicioSeleccionado(true);
        //AuthService.updateEjercicioEmpresaSeleccionado(this.ejercicioSeleccionado.id_empresa_ejercicio);
      }
    },
    async cargarPerfiles() {
      try {
        let filtro = "";

        this.perfilesUsuario = new Array<AutoCompleteTemplate>();

        this.perfilesUsuario = await ComboService.getComboAsync(
          ComboEnum.TP_RESPONSABLE_PERFIL,
          filtro
        );

        if (this.perfilesUsuario.length == 1) {
          this.perfilSeleccionado = this.perfilesUsuario[0].value.toString();
        } else {
          var defecto = this.perfilesUsuario.find(
            (x) => x.defecto == Utilidades.UNO
          );

          if (defecto) {
            this.perfilSeleccionado = defecto.value.toString();
          } else {
            this.perfilSeleccionado = this.perfilesUsuario[0].value.toString();
          }
        }
      } catch (ex) {
        Utilidades.Message({
          message: ex.toString(),
          error: true,
        });
      } finally {
        AuthService.updatePerfilSeleccionado(this.perfilSeleccionado);
      }
    },
    async cargarEmpFact() {
      await EmpresaFactService.getEmpresaFactByIdAsync(
        this.empresaSeleccionada.id_empresa
      )
        .then(async (x) => {
          this.empFact = x.data[0];
        })
        .catch((y) =>
          Utilidades.Message({
            message: Constantes.ERROR_ACTUALIZAR_DATOS + " " + y.response.data,
            error: true,
          })
        );
    },
    getImgUrl(img) {
      if (!img) img = "spain.jpg";

      return require("../assets/hyper/images/flags/" + img);
    },
    openTagsPagina() {
      let aux = router.currentRoute.matched[0].instances.default;
      (aux as any).abrirModalTagsPagina();
    },
    openTareasPagina() {
      let aux = router.currentRoute.matched[0].instances.default;
      (aux as any).abrirModalTareasPagina();
    },
  },
});
